"use client"

import { useState } from "react"

const Newsletter = () => {
  const [email, setEmail] = useState("")

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
  }

  return (
    <div className="flex flex-col gap-y-3 max-w-sm">
      <span className="font-serif text-lg text-sidebarText">
        Get 10% off your first box
      </span>
      <p className="text-sm text-footerMuted">
        Plus sample tips and new arrivals.
      </p>
      <form
        onSubmit={handleSubmit}
        className="flex items-center gap-x-2"
      >
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@email.com"
          className="flex-1 bg-card border border-line rounded-[10px] px-3 py-2 text-sm text-ink placeholder:text-muted outline-none focus:border-clay transition-colors"
        />
        <button
          type="submit"
          className="shrink-0 bg-clay hover:bg-clay-deep text-bone rounded-[10px] px-4 py-2 text-sm transition-colors"
        >
          Sign up
        </button>
      </form>
    </div>
  )
}

export default Newsletter
